
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { useDevAuth } from "@/stores/useDevAuth";

const AdminLogin = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { setDevAuthenticated } = useDevAuth();

  useEffect(() => {
    // Automatically authenticate without password
    setDevAuthenticated(true);
    navigate("/");
    toast({
      title: "Welcome Developer! 👋",
      description: "Successfully logged in to development environment",
    });
  }, [navigate, setDevAuthenticated, toast]);

  return null;
};

export default AdminLogin;
